__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "abb-zelda-portal-ts";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@abb-motion-ux/commonux-web-components-react", "7.2.0-alpha.5", () => (Promise.all([__webpack_require__.e(4558), __webpack_require__.e(2945), __webpack_require__.e(799), __webpack_require__.e(6715), __webpack_require__.e(664), __webpack_require__.e(5030), __webpack_require__.e(844), __webpack_require__.e(686), __webpack_require__.e(5432), __webpack_require__.e(4793), __webpack_require__.e(2385), __webpack_require__.e(4067), __webpack_require__.e(8958), __webpack_require__.e(2666), __webpack_require__.e(8997), __webpack_require__.e(2335), __webpack_require__.e(2827), __webpack_require__.e(1267), __webpack_require__.e(9822), __webpack_require__.e(8673), __webpack_require__.e(7598), __webpack_require__.e(143), __webpack_require__.e(9032), __webpack_require__.e(3800), __webpack_require__.e(5052), __webpack_require__.e(779), __webpack_require__.e(6513), __webpack_require__.e(959), __webpack_require__.e(4730), __webpack_require__.e(1963), __webpack_require__.e(1883), __webpack_require__.e(3802), __webpack_require__.e(3149), __webpack_require__.e(8413), __webpack_require__.e(5663), __webpack_require__.e(3047), __webpack_require__.e(8003), __webpack_require__.e(3854), __webpack_require__.e(8511), __webpack_require__.e(725), __webpack_require__.e(5969)]).then(() => (() => (__webpack_require__(43597))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(9107), __webpack_require__.e(6627), __webpack_require__.e(3501), __webpack_require__.e(1799), __webpack_require__.e(465), __webpack_require__.e(690), __webpack_require__.e(961), __webpack_require__.e(3884)]).then(() => (() => (__webpack_require__(40961))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(90770);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};